import axios from 'axios';
import CONSTANTS from '@/helpers/constants';

export const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem(CONSTANTS.AUTH_TOKEN) || '';
  config.headers.Authorization = `Bearer ${token}`; // eslint-disable-line
  return config;
});

export default {
  install(Vue, store) {
    Vue.prototype.$axios = axiosInstance;
    if (store) {
      store.$axios = axiosInstance;
    }
  },
};
